module.exports = __webpack_public_path__ + "img/juno-small-dark.dd85d53f.svg";